import React, { useEffect, useState } from 'react'
import { HamburgerIcon } from 'components/icons'
import { useRouter } from 'next/router'
import { useDispatch, useSelector } from 'react-redux'
import { useScreenWidth } from 'data/hooks/useScreenWidth'
import { setLoginModalOpen } from 'store/auth'
import { RootState } from 'store'
import NavigationModal from 'components/modals/NavigationModal'
import CustomerProfileModal from 'components/modals/CustomerProfileModal'
import classNames from 'classnames'

type PropType = {
  variant?: 'logo'
}

const MobilePublicNavbarTrigger = ({ variant }: PropType) => {

  const router = useRouter()
  const dispatch = useDispatch()
  const [profileModalOpen, setProfileModalOpen] = useState(false)
  const [navigationModalOpen, setNavigationModalOpen] = useState(false)

  const isMobile = useScreenWidth(1024).isMobile

  const { user, checked } = useSelector((state: RootState) => ({
    user: state.auth.user,
    checked: state.auth.checked,
  }))

  const openModal = () => {
    if (checked && user) {
      setProfileModalOpen(true)
    } else if (isMobile) {
      setNavigationModalOpen(true)
    } else {
      dispatch(setLoginModalOpen(true))
    }
  }

  useEffect(() => {
    setNavigationModalOpen(false)
    setProfileModalOpen(false)
  }, [router])

  return (
    <>
      <button
        type="button"
        className={classNames('text-16 cursor-pointer', {
          'absolute right-20 top-20': variant === 'logo',
          'w-full self-center justify-self-center flex justify-center items-center': !variant,
        })}
        onClick={() => openModal()}
      >
        <HamburgerIcon/>
        <div className="sr-only">Menu Button</div>
      </button>
      {navigationModalOpen
          && <NavigationModal
            isOpen={navigationModalOpen}
            onClose={() => setNavigationModalOpen(false)}
            onLogin={() => {
              setNavigationModalOpen(false)
              dispatch(setLoginModalOpen(true))
            }}
          />
      }

      <CustomerProfileModal
        isOpen={profileModalOpen}
        onClose={() => setProfileModalOpen(false)}
      />
    </>
  )
}

export default MobilePublicNavbarTrigger
